import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthContext } from './common/context/auth/auth-context'
import ProtectedRoute from './components/protected-route'
import Login from './login/login'
import { SetPassword } from './auth/set-password'
import DashboardRouter from './dashboard/dashboard-router'
import Metrics from './metrics/metrics-fullscreen'
import Tasks from './tasks/tasks-fullscreen'
import ProtectedLayout from './components/protected-layout'
import { AuthContextProvider } from './common/context/auth/auth-context-provider'
import { ThemeContextProvider } from './common/context/theme/theme-context-provider'
import Account from './account/account'
import Preferences from './preferences/preferences'
import CropTemplates from './crop/crop-templates/crop-templates'
import CropTimelineFullscreen from './crop/crop-schedule/crop-timeline-fullscreen'
import MapFullscreen from './map/map-fullscreen'
import JournalPage from './journal/journal-page'
import { MarketingLayout } from './marketing/marketing-layout'
import { Home } from './marketing/home'
import { About } from './marketing/about'
import { Support } from './marketing/support'
import { Legal } from './marketing/legal'
import { Attributions } from './marketing/attributions'
import { Sitemap } from './marketing/sitemap'
import { ArticlePage } from './marketing/articles/article-page'
import { FeatureGate } from './common/feature-gate'

function App() {
  return (
    <ThemeContextProvider>
      <BrowserRouter>
        <AuthContextProvider>
          <Routes>
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/support" element={<Support />} />
              <Route path="/privacy-policy" element={<Navigate to="/legal" replace />} />
              <Route path="/legal" element={<Legal />} />
              <Route path="/attributions" element={<Attributions />} />
              <Route path="/sitemap" element={<Sitemap />} />
              <Route path="/articles/:slug" element={<ArticlePage />} />
            </Route>

            <Route path="/login" element={<Login />} />

            <Route element={<ProtectedRoute />}>
              <Route path="/set-password" element={<SetPassword />} />
              <Route element={<ProtectedLayout />}>
                <Route path="/account" element={<Account />} />
                <Route path="/preferences" element={<Preferences />} />
                <Route path="/dashboard" element={<DashboardRouter />} />
                <Route path="/timeline" element={<FeatureGate feature="page_timeline"><CropTimelineFullscreen /></FeatureGate>} />
                <Route path="/map" element={<FeatureGate feature="page_map"><MapFullscreen /></FeatureGate>} />
                <Route path="/metrics" element={<FeatureGate feature="page_metrics"><Metrics /></FeatureGate>} />
                <Route path="/tasks" element={<FeatureGate feature="page_tasks"><Tasks /></FeatureGate>} />
                <Route path="/templates" element={<FeatureGate feature="page_templates"><CropTemplates /></FeatureGate>} />
                <Route path="/journal" element={<JournalPage />} />
              </Route>
            </Route>
          </Routes>
        </AuthContextProvider>
      </BrowserRouter>
    </ThemeContextProvider>
  )
}

export default App
